const titles = [
  { value: 'Mr', name: 'Mr' },
  { value: 'Mrs', name: 'Mrs' },
  { value: 'Ms', name: 'Ms' },
  { value: 'Prof', name: 'Prof' },
  { value: 'Dr', name: 'Dr' },
];
export default titles;